import { X, Scale } from "lucide-react";
import { getDisplayData } from "@/utils/formatFirmDisplay";

export const CompareBar = ({ count, firms, onClear, onCompare, onRemove }) => {
  if (count === 0) return null;
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-xl border-t border-[#2979FF]/30 shadow-2xl shadow-blue-500/10 transition-all" data-testid="compare-bar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3 overflow-x-auto">
          <Scale size={18} className="text-[#2979FF] flex-shrink-0" />
          <div className="flex gap-2">
            {firms.map(firm => {
              const fd = getDisplayData(firm, "1-step");
              const brandColor = fd?.brandColor || "#3B82F6";
              return (
                <div key={firm.id} className="flex items-center gap-2 bg-slate-800 pl-1 pr-2 py-1 rounded-lg border border-slate-700/60">
                  <div className="w-7 h-7 rounded-md flex items-center justify-center text-white font-bold text-[10px]" style={{ background: brandColor }}>
                    {firm.icon}
                  </div>
                  <span className="text-xs text-white font-medium whitespace-nowrap">{firm.name}</span>
                  <button onClick={() => onRemove(firm.id)} className="text-slate-500 hover:text-white ml-1" data-testid={`compare-remove-${firm.slug}`}>
                    <X size={12} />
                  </button>
                </div>
              );
            })}
          </div>
          {count < 2 && <span className="text-xs text-slate-500 whitespace-nowrap">Select {2 - count} more to compare</span>}
        </div>
        <div className="flex items-center gap-2 ml-3 flex-shrink-0">
          <button onClick={onClear} className="text-xs text-slate-500 hover:text-white px-3 py-2 rounded-lg transition-colors" data-testid="compare-clear">
            Clear
          </button>
          <button
            onClick={onCompare}
            disabled={count < 2}
            data-testid="compare-open-btn"
            className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all ${
              count >= 2
                ? 'bg-[#2979FF] text-white hover:bg-[#1565C0] shadow-lg shadow-blue-500/25'
                : 'bg-slate-800 text-slate-500 cursor-not-allowed'
            }`}
          >
            Compare {count >= 2 ? `(${count})` : ''}
          </button>
        </div>
      </div>
    </div>
  );
};
